import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { shellConfig } from "./lib/shell";
import "@fontsource/merriweather/400.css";
import "@fontsource/merriweather/700.css";
import "./styles/tokens.css";

document.documentElement.dataset.shell = shellConfig.target;
document.title = shellConfig.longName;
document.querySelector<HTMLLinkElement>("#pwa-manifest")?.setAttribute("href", `/manifest-${shellConfig.target}.webmanifest`);
document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute("content", shellConfig.themeColor);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).then((registration) => {
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("sage:sw-update", { detail: registration }));
          }
        });
      });
    }).catch(() => undefined);
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
